import * as types from "./types";

const mutations = {
    [types.GET_BUDGET_LIST](state, budgetList) {
        state.budgetList = budgetList;
    },
    [types.POST_BUDGET](state, id) {
        state.budgetId = id;
    },
    [types.DELETE_BUDGET](state, id) {
        state.budgetId = id;
    },
    [types.UPDATE_BUDGET](state, id) {
        state.budgetId = id;
    },
    [types.LOADING_ITEM](state, loading) {
        state.loading = loading;
    },
    [types.GET_BUDGET_BY_ID](state, id) {
        state.budgetId = id;
    },
};

export default mutations;